var themes = {
  // main themes
  primary: 'tds-btn--primary',
  secondary: 'tds-btn--secondary',
  tertiary: 'tds-btn--tertiary',
  'primary-consent': 'tds-btn--primary-consent',
  // monotone
  'primary-monotone': 'tds-btn--primary-monotone',
  'secondary-monotone': 'tds-btn--secondary-monotone',
  'tertiary-monotone': 'tds-btn--tertiary-monotone',
  // inverse
  'primary-inverse': 'tds-btn--primary-inverse',
  'secondary-inverse': 'tds-btn--secondary-inverse',
  'tertiary-inverse': 'tds-btn--tertiary-inverse',
  // warning
  'primary-warning': 'tds-btn--primary-warning',
  'secondary-warning': 'tds-btn--secondary-warning',
  'tertiary-warning': 'tds-btn--tertiary-warning',
  // marketing
  'primary-marketing': 'tds-btn--primary-marketing',
  'secondary-marketing': 'tds-btn--secondary-marketing',
  'tertiary-marketing': 'tds-btn--tertiary-marketing'
};
var sizes = ['sm', 'md', 'lg', 'xl'];
var customProps = ['href', 'type', 'size', 'className', 'theme', 'isBlock', 'children', 'loading', 'loadingFixedWidth', 'target', 'icon', 'iconOnly', 'innerRef', 'iconRight', 'iconRounded', 'blockAlignedLeft', 'blockAlignedRight', 'onIconClick'];
export { themes, sizes, customProps };